module.exports = __webpack_public_path__ + "img/dimequest-filters-wire.3eaefe6f.png";